import React, { useState, useEffect } from "react";

import LogoImg from "../../../assets/icons/logo.svg";
import "./logo.css";

const Logo = ({ showSidbarMarginLeft }) => {
  const [logoState, setLogoState] = useState(true);

  useEffect(() => {
    showSidbarMarginLeft !== undefined && setLogoState(false);
  }, [showSidbarMarginLeft]);

  return (
    <div className="relative  ">
      <div
        style={{ direction: "rtl" }}
        className={` logo-class   flex flex-row  w-1/3 mx-auto  my-auto screen500:w-fit
        
        ${logoState && "logo-diffrent-screens"}
        ${
          logoState
            ? "    justify-center -mt-10    px-14  z-10 screen700:-mt-7  "
            : showSidbarMarginLeft
            ? "logoMargin "
            : "undoLogoMargin "
        }
       
          screen1200:px-8
          screen1000:px-0
        `}
      >
        <div className="screen500:my-auto  screen800:pr-2 ">
          <img
            src={LogoImg}
            alt="لوگو صرافی روبین"
            className="w-28 
          screen800:w-20
          screen700:w-16
          screen500:w-10 
          "
          />
        </div>
        <div
          className={`my-auto  text-center  w-full  mx-auto screen500:pb-2 ${
            showSidbarMarginLeft && "-ml-7"
          } `}
        >
          <h1
            className={`
          ${
            showSidbarMarginLeft
              ? "text-[10px] mt-2  "
              : `tracking-wider text-3xl  screen800:text-2xl screen700:text-lg  screen500:text-[16px]`
          }
          `}
          >
            صرافی روبین
          </h1>
          <h1
            className={`${
              showSidbarMarginLeft
                ? "text-[9px]  "
                : "text-2xl screen1000:text-lg screen700:text-sm  screen500:text-xs"
            }`}
          >
            Robin Exchange
          </h1>
        </div>
      </div>

      <h2
        style={{ direction: "rtl" }}
        className={` w-[74%]   mx-auto text-justify py-16  screen700:py-8 screen500:pt-0 
        ${
          showSidbarMarginLeft
            ? "text-[10px] "
            : " text-xl screen700:text-xs screen1550:text-lg screen1000:text-[16px] tracking-wide leading-10"
        }
        `}
      >
        شرکت تضامنی اسماعیل کوشاسی و شرکا ( صرافی روبین ) با شماره ثبت 547990 
        انجام فعالیتهای ارزی در چارچوب بانک مرکزی و معاملات انواع مسکوکات را
        عهده‌دار می‌باشد.
      </h2>
    </div>
  );
};

export default Logo;
